// Exact values from theme.css --fs-* and --fw-* variables
export const FontFamily = {
  sans: 'IBM Plex Sans',
  mono: 'IBM Plex Mono',
};

export const FontSize = {
  xs:  11,
  sm:  12,
  md:  13,
  lg:  15,
  xl:  18,
  '2xl': 22,
  '3xl': 28,
};

export const FontWeight = {
  regular:  '400' as const,
  medium:   '500' as const,
  semibold: '600' as const,
  bold:     '700' as const,
};

export const LineHeight = {
  tight:  1.25,
  normal: 1.45,
  relaxed: 1.6,
};
